import { TrackEvent, EventCategory } from '../types/student'

export const TRACK_EVENTS: TrackEvent[] = [
  // Sprints
  { id: '100m', name: '100m', category: EventCategory.SPRINTS, distance: 100, isFieldEvent: false },
  { id: '200m', name: '200m', category: EventCategory.SPRINTS, distance: 200, isFieldEvent: false },
  { id: '400m', name: '400m', category: EventCategory.SPRINTS, distance: 400, isFieldEvent: false },

  // Distance
  {
    id: '800m',
    name: '800m',
    category: EventCategory.DISTANCE,
    distance: 800,
    isFieldEvent: false,
  },
  {
    id: '1500m',
    name: '1500m',
    category: EventCategory.DISTANCE,
    distance: 1500,
    isFieldEvent: false,
  },
  {
    id: '1600m',
    name: '1600m',
    category: EventCategory.DISTANCE,
    distance: 1600,
    isFieldEvent: false,
  },
  {
    id: '3200m',
    name: '3200m',
    category: EventCategory.DISTANCE,
    distance: 3200,
    isFieldEvent: false,
  },
  {
    id: '5000m',
    name: '5000m',
    category: EventCategory.DISTANCE,
    distance: 5000,
    isFieldEvent: false,
  },
  {
    id: '10000m',
    name: '10000m',
    category: EventCategory.DISTANCE,
    distance: 10000,
    isFieldEvent: false,
  },

  // Hurdles
  {
    id: '100h',
    name: '100m Hurdles',
    category: EventCategory.HURDLES,
    distance: 100,
    isFieldEvent: false,
  },
  {
    id: '110h',
    name: '110m Hurdles',
    category: EventCategory.HURDLES,
    distance: 110,
    isFieldEvent: false,
  },
  {
    id: '300h',
    name: '300m Hurdles',
    category: EventCategory.HURDLES,
    distance: 300,
    isFieldEvent: false,
  },
  {
    id: '400h',
    name: '400m Hurdles',
    category: EventCategory.HURDLES,
    distance: 400,
    isFieldEvent: false,
  },

  // Jumps
  { id: 'high_jump', name: 'High Jump', category: EventCategory.JUMPS, isFieldEvent: true },
  { id: 'long_jump', name: 'Long Jump', category: EventCategory.JUMPS, isFieldEvent: true },
  { id: 'triple_jump', name: 'Triple Jump', category: EventCategory.JUMPS, isFieldEvent: true },
  { id: 'pole_vault', name: 'Pole Vault', category: EventCategory.JUMPS, isFieldEvent: true },

  // Throws
  { id: 'shot_put', name: 'Shot Put', category: EventCategory.THROWS, isFieldEvent: true },
  { id: 'discus', name: 'Discus', category: EventCategory.THROWS, isFieldEvent: true },
  { id: 'javelin', name: 'Javelin', category: EventCategory.THROWS, isFieldEvent: true },
  { id: 'hammer', name: 'Hammer Throw', category: EventCategory.THROWS, isFieldEvent: true },

  // Multi Events
  { id: 'decathlon', name: 'Decathlon', category: EventCategory.MULTI_EVENTS, isFieldEvent: false },
  {
    id: 'heptathlon',
    name: 'Heptathlon',
    category: EventCategory.MULTI_EVENTS,
    isFieldEvent: false,
  },
  {
    id: 'pentathlon',
    name: 'Pentathlon',
    category: EventCategory.MULTI_EVENTS,
    isFieldEvent: false,
  },
]

export const EVENT_CATEGORIES = Object.values(EventCategory)

export const FIELD_EVENTS = TRACK_EVENTS.filter(event => event.isFieldEvent)
export const TRACK_EVENTS_ONLY = TRACK_EVENTS.filter(event => !event.isFieldEvent)

export const EVENTS_BY_CATEGORY = {
  [EventCategory.SPRINTS]: TRACK_EVENTS.filter(e => e.category === EventCategory.SPRINTS),
  [EventCategory.DISTANCE]: TRACK_EVENTS.filter(e => e.category === EventCategory.DISTANCE),
  [EventCategory.HURDLES]: TRACK_EVENTS.filter(e => e.category === EventCategory.HURDLES),
  [EventCategory.JUMPS]: TRACK_EVENTS.filter(e => e.category === EventCategory.JUMPS),
  [EventCategory.THROWS]: TRACK_EVENTS.filter(e => e.category === EventCategory.THROWS),
  [EventCategory.MULTI_EVENTS]: TRACK_EVENTS.filter(e => e.category === EventCategory.MULTI_EVENTS),
}

export const CATEGORY_LABELS: Record<EventCategory, string> = {
  [EventCategory.SPRINTS]: 'Sprints',
  [EventCategory.DISTANCE]: 'Distance',
  [EventCategory.HURDLES]: 'Hurdles',
  [EventCategory.JUMPS]: 'Jumps',
  [EventCategory.THROWS]: 'Throws',
  [EventCategory.MULTI_EVENTS]: 'Multi Events',
}
